import { strVal } from "@paroi/data-formatters-lib";
import { useParams } from "react-router-dom";
import { updateOrganization } from "../../../../api/application/organization";
import useGetOrganization from "../../../hooks/useGetOrganization";
import Navbar from "../../parts/Navbar/Navbar";
import Spinner from "../../utils/Spinner/Spinner";
import OrganizationForm from "../OrganizationForm";

export default function OrganizationEditPage() {
  const { organizationId } = useParams();
  const formatedId = strVal(organizationId);
  const { loadingOrganization, organization } = useGetOrganization({
    id: formatedId,
    preloadData: true,
  });
  return (
    <div className="OrganizationEditPage">
      <Navbar pageTitle="Modifier une organisation" />

      {loadingOrganization ? (
        <Spinner />
      ) : (
        <div className="OrganizationCreatePage-content Container">
          <OrganizationForm
            submitBtnLabel="Modifier la structure"
            onSubmit={(val) => updateOrganization(formatedId, val)}
            initialValues={organization}
          />
        </div>
      )}
    </div>
  );
}
